<template>
  <BModalForm
    ref="modal"
    v-bind="$attrs"
    :create-default-data="createDefaultData"
    :transform-data="transformData"
    max-width="900px"
    @closed="$emit('closed')"
  >
    <template #title-text="{ editable, viewOnly, form }">
      {{ getTitle(editable || viewOnly, form) }}
    </template>

    <template #default="{ editable, viewOnly, form }">
      <PublicationDataCollectionsForm
        :form="form"
        :publication="publication"
        :disabled="editable || viewOnly"
      />
    </template>
  </BModalForm>
</template>

<script>
import { PublicationDataCollectionsModel as Model } from '../Model'

import BModalForm from '@/components/modals/BModalForm.vue'
import PublicationDataCollectionsForm, { createDefaultData } from './PublicationDataCollectionsForm.vue'


export default {
  name: 'PublicationDataCollectionsModal',
  components: {
    BModalForm,
    PublicationDataCollectionsForm,
  },
  inheritAttrs: false,
  props: {
    publication: {
      type: Object,
      required: true,
      validator: (prop) => (
        prop
        && 'start_at' in prop
        && 'end_at' in prop
        && 'participants' in prop
      ),
    },
  },
  data: (vm) => ({
    createDefaultData: () => createDefaultData(
      vm.publication.start_at,
      vm.publication.end_at,
    ),
  }),
  methods: {
    open() {
      return this.$refs.modal.open()
    },
    close() {
      return this.$refs.modal.close()
    },
    getTitle(editable, form) {
      if (editable) return Model.page_title.view(form)
      return form.id ? Model.page_title.edit : Model.page_title.create
    },
    transformData(data) {
      return {
        ...data,

        form_template: void 0,
        form_template_id: data.form_template.id,

        participants: void 0,
        publication_id: void 0,

        is_report_view: !!data.is_report_view,
        is_scannable: !!data.is_scannable,
      }
    },
  },
}
</script>
